import { MAX_ROLE_NAME_LENGTH, MIN_INPUT_LENGTH } from "@finway-group/shared/lib/utils/validators"
import { Rule } from "antd/lib/form"
import { generalRules } from "~Components/forms/rules/common/general.rules"
import { stringRules } from "~Components/forms/rules/common/string.rules"
import i18n from "~Shared/locales/i18n"

export const createRoleRules = () => ({
    template: [{ required: true, message: i18n.t("validation:required") }] as Array<Rule>,
    name: [
        // keep line breaks
        generalRules.required,
        stringRules.noExcessWhitespace,
        stringRules.minLength(MIN_INPUT_LENGTH),
        stringRules.maxLength(MAX_ROLE_NAME_LENGTH),
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
})
